import { render, staticRenderFns } from "./bestUSAAdd.vue?vue&type=template&id=3f46c5b7&"
import script from "./bestUSAAdd.vue?vue&type=script&lang=js&"
export * from "./bestUSAAdd.vue?vue&type=script&lang=js&"
import style0 from "./bestUSAAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports